import React from 'react';
import Title from 'components/UI/Title';
import Logos from 'components/ModalAside/components/Logos';

import * as styles from './DefaultLogosFooter.module.scss';

export default function DefaultLogosFooter({ title }) {
  return (
    <>
      <Title className={styles.title} tag="h4" color="white">
        {title}
      </Title>
      <Logos />
    </>
  );
}
